

export class VehicleModelSelectByCompanyIdAndFuelTypeInput implements IVehicleModelSelectByCompanyIdAndFuelTypeInput {
    /** The auto-generated id of the vehicle company master */
    vehicleCompanyId!: number;
    /** The auto-generated id of the vehicle type master */
    vehicleTypeId!: number;

    constructor(data?: IVehicleModelSelectByCompanyIdAndFuelTypeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleCompanyId = _data["vehicleCompanyId"];
            this.vehicleTypeId = _data["vehicleTypeId"];
        }
    }

    static fromJS(data: any): VehicleModelSelectByCompanyIdAndFuelTypeInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleModelSelectByCompanyIdAndFuelTypeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleCompanyId"] = this.vehicleCompanyId;
        data["vehicleTypeId"] = this.vehicleTypeId;
        return data; 
    }
}

export interface IVehicleModelSelectByCompanyIdAndFuelTypeInput {
    /** The auto-generated id of the vehicle company master */
    vehicleCompanyId: number;
    /** The auto-generated id of the vehicle type master */
    vehicleTypeId: number;
}

